import React, { useContext, useEffect, useRef, useState } from "react";
import { Collapse, Modal } from "react-bootstrap";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Modal as Modal2 } from "@mui/material";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import "./Accordian.css";
import { APICall } from "../../../Helpers/API/APICalls";
import { APICalls } from "../../../Helpers/API/APICalls2";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { BsExclamationCircle } from "react-icons/bs";
import { Event } from "react-toastify/dist/core";
import {
  getTestCaseHistory,
  getTCNatureOfIssueStatus,
  insertTestCasesHistory,
  insertTestCaseIssue,
  UpdateTestCaseStatus,
  getEmployeeForTestCase,
  GetTestCaseByID,
  getEmployeeResponsibleForTestCase,
} from "../../../Helpers/API/APIEndPoints";
import uuid from "react-uuid";
import { data } from "autoprefixer";
//For TL & BA
const Accordian5 = ({
  data: mainData,
  statusDropdown,
  TCnatureOfIssueDropdown,
  setDashboardData,
}) => {
  const { EmployeeId, RoleId } = getContext();
  const [isActive, setIsActive] = useState<boolean>(false);
  //const [status, setStatus] = useState<any>({});
  const [assignedToOptions, setAssignedToOptions] = useState<any>([]);
  const [assignedTo, setAssignedTo] = useState<any>({
    value: Number(EmployeeId),
  });
  //const [natureOfIssueOptions, setNatureOfIssueOptions] = useState<any>([]);
  const [natureOfIssue, setNatureOfIssue] = useState<any>({});
  const [FileNames, setFileNames] = useState<string[]>([]); // Updated for multiple files
  const [TcFile, setTCFile] = useState<any[]>([]); // Array for multiple files
  const [fileCount, setFileCount] = useState(0); // State to store the count of valid files
  const [errorMsg, setErrorMsg] = useState(""); //Amogh
  const [SharePointLink, setSharePointLink] = useState(""); //Amogh
  const [TestCaseSharePointLinkId, setTestCaseSharePointLinkId] = useState(""); //Amogh

  const [testData, setData] = useState(mainData);

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const [estEffortHours, setEstEffortHours] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [issue, setIssue] = useState("");
  const [hideFields, setHideFields] = useState(false);
  const [disableStatus, setDisableStatus] = useState(false);
  const [preRequistie, setPreRequistie] = useState("");
  const [expectedResult, setExpectedResult] = useState("");
  const [requirementTitle, setRequirementTitle] = useState("");
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [testCaseHistoryData, setTestCaseHistoryData] = useState([]);
  const [remark, setRemark] = useState("");
  const RoleIdArray = RoleId.split(",");
  const [responsiblePersonOptions, setResponsiblePersonOptions] = useState<any>(
    []
  );
  const [responsibleperson, setResponsiblePerson] = useState<any>([]);
  let formErrorObj = {};

  const handleOpen = async (id) => {
    gettestcasehistory(id);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  useEffect(() => {
    (async () => {
      await gettestcasehistory(testData.id);
    })();
  }, [start, pageSize]);
  const gettestcasehistory = async (id) => {
    let gettestcasetid = {
      testCaseId: id,
      pageSize: pageSize,
      start: start,
    };
    const { data } = await APICall(getTestCaseHistory, "POST", gettestcasetid);
    //console.log(data);
    if (data != null || data != undefined) {
      await data.testCaseData.map(async (testcaseh) => {
        testcaseh.timesheetDate = await moment(testcaseh.timesheetDate).format(
          "DD/MM/YYYY"
        );
      });
      setTestCaseHistoryData(data.testCaseData);
      setCount(data.count);
    }
  };

  const gridColumns = [
    // {
    //   name: "testCaseId",
    //   label: "Testcase Id",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: false,
    //   },
    // },
    {
      name: "statusTitle",
      label: "Status",
      options: {
        filter: false,
      },
    },
    {
      name: "timesheetDate",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "empName",
      label: "User",
      options: {
        filter: false,
      },
    },
  ];

  // const handleFiles = (e: any, apiFieldName) => {
  //   // setTCFile(e.target.files[0]);
  //   const file = e.target.files[0];

  //   if (!file || file === "" || file.toString().trim() === "") {
  //     setFormErrors((prevState) => ({
  //       ...prevState,
  //       ["poFile_isEmpty"]: "Please upload PO",
  //     }));
  //   } else {
  //     setFormErrors((prevState) => ({
  //       ...prevState,
  //       ["poFile_isEmpty"]: undefined,
  //     }));
  //   }

  //   if (file) {
  //     if (
  //       file.type === "application/pdf" ||
  //       file.type === "application/msword" ||
  //       file.type === "image/png" ||
  //       file.type === "image/jpeg" ||
  //       file.type === "message/rfc822" ||
  //       file.type ===
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
  //       file.type === "application/vnd.ms-excel" ||
  //       file.type ===
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
  //       file.type ===
  //         "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
  //       file.type ===
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  //     ) {
  //       setFileName(file.name);
  //       setTCFile(file);
  //       setErrorMsg("");
  //     } else {
  //       setErrorMsg(
  //         "The selected file is not a PDF, DOC,PNG, JPEG, PDF, EML, XLSX, or PPTX file. Please upload a valid file."
  //       );
  //       setFileName("");
  //       setTCFile(null);
  //     }
  //   }

  //   // if(file.type === 'application/pdf' || file.type === 'application/msword' ||
  //   //     file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){

  //   //   setFileName(file.name);
  //   //   setPOFile(file);
  //   //   setErrorMsg('');
  //   // }
  //   // else{

  //   //   setErrorMsg('The selected file is not a PDF, DOC, or DOCX. Please upload a valid file.');
  //   //   setFileName('');
  //   //   setPOFile(null);
  //   // }
  // };
  const handleFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(e.target.files || []); 
  
    if (!selectedFiles.length) {
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: "Please upload at least one file",
      }));
      setFileNames([]);
      setTCFile([]);
      setFileCount(0); 
      return;
    }
  
    const allowedTypes = new Set([
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "image/png",
      "image/jpeg",
      "message/rfc822",
    ]);
  
    const validFiles: File[] = [];
    const invalidFiles: File[] = [];
  
    for (const file of selectedFiles) {
      if (allowedTypes.has(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file);
      }
    }
  
    if (validFiles.length > 5) {
      setErrorMsg("At most five files are allowed.");
      setFileNames([]);
      setTCFile([]); 
      setFileCount(0);
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: "Please upload at least one file", 
      }));
      return; 
    }
  
    
    if (validFiles.length > 0) {
      setFileNames([]);
      setTCFile(validFiles);
      setFileCount(validFiles.length);
      setErrorMsg("");
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: undefined,
      }));
    }
  
    
    if (invalidFiles.length > 0) {
      notify(
        1,
        "Some selected files are not allowed. Allowed types: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, PNG, JPEG, EML."
      );
      setErrorMsg(
        "Some selected files are not allowed. Allowed types: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, PNG, JPEG, EML."
      );
    }
  };
  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false, //prashant
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      // if (searchText !== null) {
      //   setSearchText(searchText);
      //   setStart(0);
      // } else {
      //   setSearchText("");
      // }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    //prashant
    // onChangePage: async (page) => {
    //     setStart(page * pageSize);
    // },
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    maxHeight: "650px", //prashant
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    overflow: "auto", //prashant
  };

  useEffect(() => {
    if (testData) {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      let postObject = {
        EmployeeID: EmployeeId,
        fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
        toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
        EngagementId: testData.engagementID,
      };
      (async () => {
        var { data } = await APICall(
          getEmployeeForTestCase,
          "POST",
          postObject
        );
        if (data != undefined || data != null) {
          let tempArray = [];
          await data.map((employee) => {
            let tempObj = {
              value: employee.employeeID,
              label: employee.employeeName,
            };
            if (tempObj.value == assignedTo.value) {
              setAssignedTo(tempObj);
            }
            tempArray.push(tempObj);
          });
          tempArray.sort((a, b) => a.label.localeCompare(b.label));
          setAssignedToOptions(tempArray);
        }
      })();

      // (async () => {
      //   var {data} = await APICall(getTCNatureOfIssueStatus,"POST",postObject);
      //   if (data != undefined || data != null) {
      //   let tempArray = [];
      //   await data.map((natureOfIssueStatus) => {
      //     let tempObj = {
      //       value: natureOfIssueStatus.ID,
      //       label: natureOfIssueStatus.Value,
      //     };
      //     tempArray.push(tempObj);
      //   });
      //   tempArray.sort((a, b) => a.label.localeCompare(b.label));
      //   setNatureOfIssueOptions(tempArray);
      // }
      // })();

      if (
        testData.status.id === 1 ||
        testData.status.id === 2 ||
        testData.status.id === 4 ||
        testData.status.id === 6
      ) {
        setHideFields(true);
      } else {
        setHideFields(false);
      }
      let post = {
        Id: testData.id,
      };
      (async () => {
        const { data } = await APICall(GetTestCaseByID, "POST", post);
        if (data != undefined || data != null) {
          await data.map((tc: any) => {
            setRequirementTitle(tc.requirementTitle);
            setPreRequistie(tc.preRequisties);
            setExpectedResult(tc.expectedResult);
          });
        }
      })();
      // Added a new API call for the person responsible.Raj Potdar, Date : 09-12-2024.
      (async () => {
        var { data } = await APICall(
          getEmployeeResponsibleForTestCase,
          "POST",
          postObject
        );
        if (data != undefined || data != null) {
          let tempArray = [];
          await data.map((employee) => {
            let tempObj = {
              value: employee.employeeID,
              label: employee.employeeName,
            };
            if (tempObj.value == assignedTo.value) {
              setResponsiblePerson(tempObj);
            }
            tempArray.push(tempObj);
          });
          tempArray.sort((a, b) => a.label.localeCompare(b.label));
          setResponsiblePersonOptions(tempArray);
        }
      })();
    }
  }, []);

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "status") {
      setData((prev) => {
        return {
          ...prev,
          status: event,
        };
      });
      if (
        event.id === 1 ||
        event.id === 2 ||
        event.id === 4 ||
        event.id === 6
      ) {
        setHideFields(true);
      } else {
        setHideFields(false);
      }
    }
    if (apiFieldName == "assignedTo") {
      setAssignedTo(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["assignedTo_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["assignedTo_isEmpty"]: "Assigned To cannot be empty",
        }));
      }
    }
    if (apiFieldName === "nature") {
      setNatureOfIssue(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["natureofIssue_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["natureofIssue_isEmpty"]: "select Nature of Issue",
        }));
      }
    }
    if (apiFieldName == "responsibleperson") {
      setResponsiblePerson(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["responsibleperson_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["responsibleperson_isEmpty"]: "Responsible person cannot be empty",
        }));
      }
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "Issues") {
      setIssue(event.target.value);
      setFormErrors((preState) => ({
        ...preState,
        ["issue_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["issue_isEmpty"]: "Issue cannot be empty",
        }));
      }
    }
    // Omkar P
    if (apiFieldName == "Remark") {
      setRemark(event.target.value);
    }
    // Omkar P
    if (apiFieldName == "StartDate") {
      setStartDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["startDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["startDate_isEmpty"]: "Start date cannot be empty",
        }));
      }
    }
    if (apiFieldName == "EndDate") {
      setEndDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["endDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["endDate_isEmpty"]: "End date cannot be empty",
        }));
      }
    }
    if (apiFieldName == "EstEffortHours") {
      setEstEffortHours(event.target.value);
      setFormErrors((preState) => ({
        ...preState,
        ["estEffortHours_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["estEffortHours_isEmpty"]: "Estimate Effort hrs cannot be empty",
        }));
      }
    }
  };

  const submitValidation = async () => {
    await setFormErrors({});
    if (!startDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["startDate_isEmpty"]: "Start date cannot be empty",
      }));
      formErrorObj["startDate_isEmpty"] = "Start date cannot be empty";
    }

    if (!endDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["endDate_isEmpty"]: "End date cannot be empty",
      }));
      formErrorObj["endDate_isEmpty"] = "End date cannot be empty";
    }

    if (endDate < startDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["endDate_isEmpty"]: "End date cannot be smaller",
      }));
      formErrorObj["endDate_isEmpty"] = "End date cannot be smaller";
    }
    if (!assignedTo || Object.keys(assignedTo).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["assignedTo_isEmpty"]: "Assigned To cannot be empty",
      }));
      formErrorObj["assignedTo_isEmpty"] = "Assigned To cannot be empty";
    }
    if (!natureOfIssue || Object.keys(natureOfIssue).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["natureofIssue_isEmpty"]: "Nature of Issue cannot be empty ",
      }));
      formErrorObj["natureofIssue_isEmpty"] = "Nature of Issue cannot be empty";
    }
    if (issue === "") {
      setFormErrors((preState) => ({
        ...preState,
        ["issue_isEmpty"]: "Issue cannot be empty",
      }));
      formErrorObj["issue_isEmpty"] = "Issue cannot be empty";
    }
    if (estEffortHours === "") {
      setFormErrors((preState) => ({
        ...preState,
        ["estEffortHours_isEmpty"]: "Estimate Effort hrs cannot be empty",
      }));
      formErrorObj["estEffortHours_isEmpty"] =
        "Estimate Effort hrs cannot be empty";
    }
  };
  const submitFunc = async (action: any) => {
    if (action === "submit") {
      let submitObj: any = {};
      if (
        testData.status.id === 2 ||
        testData.status.id === 4 ||
        testData.status.id === 6
      ) {
        submitObj = {
          Status: testData.status.id,
          Id: testData.id,
        };

        const { data } = await APICall(UpdateTestCaseStatus, "Post", submitObj);

        let historyinsertobj = {
          TestCaseId: testData.id,
          TestCaseStatus: testData.status.id,
          CreatedBy: Number(EmployeeId),
        };
        const { data2 } = await APICall(
          insertTestCasesHistory,
          "Post",
          historyinsertobj
        );

        if (data) {
          if (data.responseStatus === 1) {
            notify(0, "TestCase Status Updated Successfully");
            if (testData.status.id === 4) {
              setDisableStatus(true);
            } else {
              setDisableStatus(false);
            }
          } else {
            notify(1, "Something went wrong!");
          }
        }
        setData((prev) => {
          return {
            ...prev,
            Status: testData.status.id,
          };
        });
        setIsActive(!isActive);
      } else {
        await submitValidation();
        let isEmpty = Object.values(formErrorObj).every(
          (f) => f === "" || f === null || f === undefined
        );
        if (isEmpty === true) {
          // submitObj = {
          //   TestCaseUid: uuid(),
          //   TestCaseId: testData.id,
          //   IssueName: issue,
          //   AssignedTo: assignedTo.value,
          //   NatureOfIssue: natureOfIssue.id,
          //   PlannedStartDate: startDate,
          //   PlannedEndDate: endDate,
          //   HoursAssigned: Number(estEffortHours),
          //   Remarks: remark,
          //   CreatedBy: Number(EmployeeId),
          //   // Added a new object for the test cased new requirement, Raj Potdar, Date : 09-12-2024
          //   ResponsiblePerson:
          //     responsibleperson.map((e) => e.value).join(",") || null,
          //   EngagementID: testData.engagementID,
          // };
          let submitObj = new FormData();

          submitObj.append("TestCaseUid", uuid());
          submitObj.append("TestCaseId", testData.id);
          submitObj.append("IssueName", issue);
          submitObj.append("AssignedTo", assignedTo.value);
          submitObj.append("NatureOfIssue", natureOfIssue.id);
          submitObj.append("PlannedStartDate", startDate.toISOString());
          submitObj.append("PlannedEndDate", endDate.toISOString());
          submitObj.append("HoursAssigned", String(estEffortHours));
          submitObj.append("Remarks", remark? remark : "");
          // submitObj.append(
          //   "TestCaseSharePointLinkId",
          //   TestCaseSharePointLinkId ? TestCaseSharePointLinkId : ""
          // ); //Amogh
          // submitObj.append(
          //   "SharePointLink",
          //   SharePointLink ? SharePointLink : ""
          // ); //Amogh
          submitObj.append("EmpId", String(EmployeeId));

          // console.log(responsibleperson, "ppp");
          // Responsible Person
          // const res= responsibleperson? responsibleperson.map((e) => e.value).join(","):0
          // submitObj.append(
          //   "ResponsiblePerson",
          //   res,
          // );

          submitObj.append(
            "ResponsiblePerson",
            responsibleperson && responsibleperson.length>0 
              ? responsibleperson.map((e) => e.value).join(",")
              : assignedTo.value
          );

          submitObj.append("EngagementID", testData.engagementID);

          // // Append the file (if available)
          // if (TcFile) {
          //   submitObj.append("File", TcFile); // The file is included in the form data
          // }
          if (TcFile) {
            Array.from(TcFile).forEach((file, index) => {
              //console.log(file)
              submitObj.append("FileList", file);
            });
          }
           //console.log("submitObj=>>", submitObj);
          const { data } = await APICalls(
            insertTestCaseIssue, // Endpoint URL
            "POST",
            submitObj // HTTP method
          );
         // console.log(data);
          let historyinsertobj = {
            TestCaseId: testData.id,
            TestCaseStatus: testData.status.id,
            CreatedBy: Number(EmployeeId),
          };
          const { data2 } = await APICall(
            insertTestCasesHistory,
            "Post",
            historyinsertobj
          );
          let updateObj = {
            Status: testData.status.id,
            Id: testData.id,
          };
          const { data1 } = await APICall(
            UpdateTestCaseStatus,
            "Post",
            updateObj
          );
          if (data) {
            if (data.responseStatus === 1) {
              notify(0, "Testcase Assigned Successfully.");
            } else {
              notify(1, data.response);
            }
          }
          // setAssignedTo({});
          setIssue("");
          setRemark("");
          // setStartDate(null);
          // setEndDate(null);
          setEstEffortHours("");
          setIsActive(!isActive);
          // setResponsiblePerson([]);
        }
      }
    }
    if (action === "reset") {
      resetFunc();
    }
  };

  const resetFunc = () => {
    setFormErrors({});
    setAssignedTo({});
    setNatureOfIssue({});
    setIssue("");
    setRemark("");
    setStartDate(null);
    setEndDate(null);
    setEstEffortHours("");
    setResponsiblePerson([]);
    setFileNames([]);
    setTCFile([]);
    setErrorMsg("");
  };

  return (
    <>
      {testData && (
        <>
          <div className="card">
            <div
              style={{ backgroundColor: "#c1d0d7 important" }}
              className="card-header"
              id="headingOne"
              onClick={() => setIsActive(!isActive)}
            >
              <div data-toggle="collapse" data-target="#collapseOne">
                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0">
                    {/* check status then render */}
                    {testData.status.id !== 1 && (
                      <i
                        className="fa fa-hourglass-end mr-2 yellow-col"
                        aria-hidden="true"
                      ></i>
                    )}
                    {testData.id} <span>-</span> {testData.title}
                    <span className="float-right">
                      {" "}
                      <i className="fa fa-chevron-down"></i>{" "}
                    </span>
                  </div>
                </div>

                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0 mt-2 sub-text">
                    <span>
                      {testData.engagement &&
                        testData.phaseName === null &&
                        testData.applicationName === null && (
                          <>{testData.engagement}</>
                        )}
                      {testData.engagement && testData.phaseName && (
                        <>
                          {testData.engagement} - {testData.phaseName}
                        </>
                      )}
                      {testData.engagement && testData.applicationName && (
                        <>
                          {testData.engagement} - {testData.applicationName}
                        </>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Collapse in={isActive}>
              <div>
                <>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                  >
                    <div className="card-body">
                      <div className="row">
                        {testData.title && (
                          <>
                            {/* <p className="p-0 m-0">Requirement - {requirementTitle}</p>
                                  <p  className="p-0 m-0">Pre Requistie - {preRequistie}</p>
                                  <p  className="p-0 m-0">Expected Result - {expectedResult}</p> */}

                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>Requirement</label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={true}
                                  textArea={true}
                                  value={requirementTitle}
                                  onChange={() => {}}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>Pre Requistie</label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={true}
                                  textArea={true}
                                  value={preRequistie}
                                  onChange={() => {}}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>Expected Result</label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={true}
                                  textArea={true}
                                  value={expectedResult}
                                  onChange={() => {}}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>
                              Status <sup>*</sup>
                            </label>
                            <SelectForm
                              options={statusDropdown}
                              placeholder="Select"
                              isDisabled={disableStatus}
                              value={testData.status}
                              onChange={(event) =>
                                selectOnChange(event, "status")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                              getOptionLabel={(st) => st.statusTitle}
                              getOptionValue={(st) => st.id}
                            />
                          </div>
                        </div>
                        {!hideFields && (
                          <>
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Assigned To <sup>*</sup>
                                </label>
                                <SelectForm
                                  options={assignedToOptions}
                                  placeholder="Select"
                                  isDisabled={
                                    RoleIdArray.includes("3") ||
                                    RoleIdArray.includes("2") ||
                                    RoleIdArray.includes("6") ||
                                    RoleIdArray.includes("8")
                                      ? false
                                      : true
                                  }
                                  value={assignedTo}
                                  onChange={(event) =>
                                    selectOnChange(event, "assignedTo")
                                  }
                                  isMulti={false}
                                  noIndicator={false}
                                  noSeparator={false}
                                />
                                <p style={{ color: "red" }}>
                                  {formErrors["assignedTo_isEmpty"]}
                                </p>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  {" "}
                                  Start by date <sup>*</sup>
                                </label>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    label="Start date"
                                    disabled={false}
                                    value={startDate}
                                    onChange={(e) =>
                                      handleTextEvent(e, "StartDate")
                                    }
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => (
                                      <TextField size="small" {...params} />
                                    )}
                                    PopperProps={{
                                      disablePortal: true,
                                      modifiers: [
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [0, 8],
                                          },
                                        },
                                        {
                                          name: "preventOverflow",
                                          options: {
                                            enabled: true,
                                            boundariesElement: "viewport",
                                          },
                                        },
                                      ],
                                    }}
                                  />
                                  <p style={{ color: "red" }}>
                                    {formErrors["startDate_isEmpty"]}
                                  </p>
                                </LocalizationProvider>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Complete by date <sup>*</sup>
                                </label>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    label="End date"
                                    disabled={
                                      testData.status.id === 1 ||
                                      testData.status.id === 2 ||
                                      testData.status.id === 4 ||
                                      testData.status.id === 6
                                        ? true
                                        : false
                                    }
                                    value={endDate}
                                    onChange={(e) =>
                                      handleTextEvent(e, "EndDate")
                                    }
                                    inputFormat="dd/MM/yyyy"
                                    PopperProps={{
                                      disablePortal: true,
                                      modifiers: [
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [0, 8],
                                          },
                                        },
                                        {
                                          name: "preventOverflow",
                                          options: {
                                            enabled: true,
                                            boundariesElement: "viewport",
                                          },
                                        },
                                      ],
                                    }}
                                    renderInput={(params) => (
                                      <TextField size="small" {...params} />
                                    )}
                                  />
                                  <p style={{ color: "red" }}>
                                    {formErrors["endDate_isEmpty"]}
                                  </p>
                                </LocalizationProvider>
                              </div>
                            </div>
                          </>
                        )}

                        {!hideFields && (
                          <>
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Issue <sup>*</sup>
                                </label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={false}
                                  textArea={true}
                                  value={issue}
                                  onChange={(e) => {
                                    handleTextEvent(e, "Issues");
                                  }}
                                />
                                <p style={{ color: "red" }}>
                                  {formErrors["issue_isEmpty"]}
                                </p>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Classification <sup>*</sup>
                                </label>
                                <SelectForm
                                  options={TCnatureOfIssueDropdown}
                                  placeholder="Select"
                                  isDisabled={false}
                                  value={natureOfIssue}
                                  onChange={(event) =>
                                    selectOnChange(event, "nature")
                                  }
                                  isMulti={false}
                                  noIndicator={false}
                                  noSeparator={false}
                                  getOptionLabel={(options) => options.value}
                                  getOptionValue={(options) => options.id}
                                />
                                <p style={{ color: "red" }}>
                                  {formErrors["natureofIssue_isEmpty"]}
                                </p>
                              </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Estimate Effort Hrs <sup>*</sup>
                                </label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={false}
                                  textArea={false}
                                  value={estEffortHours}
                                  className="numRight"
                                  onChange={(e) => {
                                    handleTextEvent(e, "EstEffortHours");
                                  }}
                                />
                                <p style={{ color: "red" }}>
                                  {formErrors["estEffortHours_isEmpty"]}
                                </p>
                              </div>
                            </div>
                          </>
                        )}

                        {/* Added a new drop-down, Raj Potdar, Date : 09-12-2024 */}
                        {!hideFields && (
                          <>
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>Responsible Person</label>
                                <SelectForm
                                  options={responsiblePersonOptions}
                                  placeholder="Select"
                                  isDisabled={
                                    RoleIdArray.includes("3") ||
                                    RoleIdArray.includes("2") ||
                                    RoleIdArray.includes("6") ||
                                    RoleIdArray.includes("8")
                                      ? false
                                      : true
                                  }
                                  value={responsibleperson}
                                  onChange={(event) =>
                                    selectOnChange(event, "responsibleperson")
                                  }
                                  isMulti={true}
                                  noIndicator={false}
                                  noSeparator={false}
                                />
                                {/* <p style={{ color: "red" }}>
                                        {
                                          formErrors[
                                            "responsibleperson_isEmpty"
                                          ]
                                        }
                                      </p> */}
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Remark</label>
                            <InputForm
                              placeholder={""}
                              isDisabled={false}
                              textArea={true}
                              rows={3}
                              value={remark}
                              onChange={(e) => {
                                handleTextEvent(e, "Remark");
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                        <div className="form-group">
                          <label>Attachments</label>
                          <div className="d-flex flex-wrap align-items-center">
                            <div
                              className="custom-file"
                              style={{
                                flex: "1 1 auto",
                                minWidth: "230px",
                                maxWidth: "250px",
                                display: "flex",
                              }}
                            >
                              <input
                                type="file"
                                accept=".pdf,.doc,.docx,.xlsx,.xls,.pptx,.png,.jpeg,.eml"
                                className="custom-file-input"
                                id="file"
                                multiple
                                aria-describedby="inputGroupFileAddon01"
                                onChange={handleFiles}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="file"
                              >
                                {fileCount > 0
                                  ? `${fileCount} file(s) selected`
                                  : "Choose files..."}
                              </label>
                            </div>
                            <button
                              className="btn btn-secondary ml-3 mt-2 mt-sm-0"
                              onClick={() => {
                                setFileNames([]);
                                setTCFile([]);
                                setErrorMsg("");
                                setFileCount(0);
                              }}
                            >
                              Clear
                            </button>
                          </div>
                          {errorMsg && (
                            <p className="text-danger mt-2">{errorMsg}</p>
                          )}
                        </div>
                      </div>


                        <div className="col-lg-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="fill-hours">
                              <a
                                className="mr-2"
                                onClick={() => handleOpen(testData.id)}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                <i className="fa fa-clock mr-1"></i> History{" "}
                              </a>
                            </div>
                            <div className="fillUpdate">
                              <div className="d-flex gap-2">
                                <button
                                  disabled={disableStatus}
                                  className="btn btn-reset"
                                  onClick={() => submitFunc("reset")}
                                >
                                  Reset
                                </button>
                                <button
                                  disabled={disableStatus}
                                  className="btn btn-submit"
                                  onClick={() => submitFunc("submit")}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </Collapse>
          </div>
          <>
            <Modal
              // open={open}
              // onClose={handleClose}
              // aria-labelledby="modal-modal-title"
              // aria-describedby="modal-modal-description"
              // hideBackdrop={true}
              show={open}
              onHide={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              backdrop="static"
              centered
              size="lg"
              scrollable={true}
            >
              <Modal.Header closeButton>
                <Modal.Title>History Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <DynamicGrid
                  options={options}
                  data={testCaseHistoryData}
                  columns={gridColumns}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </>
        </>
      )}
    </>
  );
};

export default Accordian5;
